module.exports = __webpack_public_path__ + "img/imgvectorteacher.c8e0a023.svg";